import React from 'react';

import defaultImage from '../../assets/images/user-32-04.jpg';

import AuthService from '../../services/AuthService';
import { useUiContext } from '../../context/UiContext';

export default function UsersTabsCard({
  image,
  name,
  location,
  content,
  userRole,
  link,
}) {
  const { showToast } = useUiContext();

  const switchAccount = async () => {
    try {
      const quickAuthCode = await AuthService.getQuickAuthCode();
      window.location.href = `${link}/quick-auth?token=${quickAuthCode}`;
    } catch (error) {
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    }
  };

  return (
    <div
      className="col-span-full sm:col-span-6 xl:col-span-3 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 cursor-pointer"
      onClick={switchAccount}
    >
      <div className="flex flex-col h-full">
        {/* Card top */}
        <div className="grow p-5">
          {/* Image + name */}
          <header>
            <div className="flex justify-center mb-2">
              <div className="relative inline-flex items-start">
                <img
                  className="rounded-full w-16 h-16 object-cover"
                  src={image || defaultImage}
                  width="64"
                  height="64"
                  alt={name}
                />
              </div>
            </div>
            <div className="text-center">
              <div className="inline-flex text-slate-800 dark:text-slate-100 hover:text-slate-900 dark:hover:text-white">
                <h2 className="text-xl leading-snug justify-center font-semibold">
                  {name}
                </h2>
              </div>
            </div>
            <div className="flex justify-center items-center">
              <span className="text-sm font-medium text-slate-400 -mt-0.5 mr-1 capitalize">
                {userRole}
              </span>{' '}
              <span>{location}</span>
            </div>
          </header>
          {/* Bio */}
          <div className="text-center mt-2">
            <div className="text-sm">{content}</div>
          </div>
        </div>
        {/* Card footer */}
        <div className="border-t border-slate-200 dark:border-slate-700">
          <div className="block text-center text-sm text-indigo-500 hover:text-indigo-600 dark:hover:text-indigo-400 font-medium px-3 py-4">
            <div className="flex items-center justify-center">
              <span>Switch</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
